import { render } from "./CompareTechSpecs.vue?vue&type=template&id=7e1a9e60"
import script from "./CompareTechSpecs.vue?vue&type=script&lang=js"
export * from "./CompareTechSpecs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__